// User.js
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPenToSquare } from "@fortawesome/free-solid-svg-icons"
import { useNavigate } from 'react-router-dom'
import { useGetUsersQuery } from './usersApiSlice'
import { memo } from 'react'

const User = ({ userId }) => {
    const { user } = useGetUsersQuery("usersList", {
        selectFromResult: ({ data }) => ({
            user: data?.entities[userId]
        }),
    })

    const navigate = useNavigate()

    if (!user) return null

    const handleEdit = () => navigate(`/dash/users/${userId}`)
    const isAdmin = user.roles.includes('Admin')
    return (
        <tr className={!user.active ? 'table-secondary' : ''}>
            <td className="text-center">
                <strong>{user.username}</strong>
            </td>
            <td className="text-center">
                {user.roles.map((role, i) => (
                    <span
                        key={i}
                        className={`badge me-1 ${
                            role === 'Admin' ? 'bg-primary' : 'bg-secondary'
                        }`}
                    >
                        {role}
                    </span>
                ))}
            </td>
            <td className="text-center">
                <span className={`badge ${user.active ? 'bg-success' : 'bg-danger'}`}>
                    {user.active ? 'Hoạt động' : 'Vô hiệu hóa'}
                </span>
            </td>

            <td className="text-center">
                {/* <span className={`badge ${user.phoneViewQuota > 10 ? 'bg-success' : user.phoneViewQuota > 0 ? 'bg-warning' : 'bg-danger'}`}>
                    {user.phoneViewQuota} lượt
                </span> */}

                {isAdmin ? (
                    <span className="text-muted fw-medium">—</span>
                    ) : (
                        <span className={`badge ${
                            user.phoneViewQuota > 10 
                                ? 'bg-success' 
                            : user.phoneViewQuota > 0 
                                ? 'bg-warning' 
                                : 'bg-danger'
                        }`}>
                            {user.phoneViewQuota} lượt
                        </span>
                )}

            </td>

            <td className="text-center">
                <button
                    className="btn btn-sm btn-outline-warning"
                    onClick={handleEdit}
                    title="Sửa"
                >
                    <FontAwesomeIcon icon={faPenToSquare} />
                </button>
            </td>
        </tr>
    )
}

export default memo(User)